import React, { Fragment, useState } from 'react';
import yandexImg from '../img/yandex.svg';

export { AuthBlock };

function AuthBlock(props) {
    const [showAuthServices, setShowAuthServices] = useState(false);

    function handleClick() {
        props.logout();
    }

    const authBlock = {
        notAuthorized:
            <Fragment>
                <button onClick={() => setShowAuthServices(!showAuthServices)}>Войти</button>
                {showAuthServices ? <AuthServices /> : ''}
            </Fragment>,
        authorized:
            <Fragment>
                <img src={yandexImg} alt={window.localStorage.authService} />
                <button onClick={handleClick}>Выйти</button>
            </Fragment>
    };

    return (
        <div className="auth_block">
            {props.isAuthorized
                ? authBlock.authorized
                : authBlock.notAuthorized}
        </div>
    );
}

function AuthServices() {
    function handleClick(service) {
        if (service === 'yandex') {
            window.localStorage.setItem('authService', service);
            document.location = 'https://oauth.yandex.ru/authorize?response_type=code&client_id=23640237743d46c2bc0ce60fff2f1275';
        }
    }
    return (
        <div>
            <p>войдите с помощью</p>
            <div className="auth_services">
                <button onClick={() => handleClick('yandex')}><img src={yandexImg} alt="yandex" /></button>
            </div>
        </div>
    );
}